const CADASTRO = () => import('./main.vue');
const CONSULT = () => import('./pessoa/beneficiario/consult');
const LISTBENEFICIARIO = () => import('./pessoa/beneficiario/main.vue');
const LISTPRESTADOR = () => import('./pessoa/prestador/main.vue');
const ATUALIZATION = () => import('./pessoa/beneficiario/atualizacaocadastral.vue');

const moduleRoutes = import.meta.glob('./*/routes.js', { eager: true });

const routes = [
  {
    name: 'cadastro',
    path: '/cadastro',
    component: CADASTRO,
    meta: {
      breadcrum: 'Cadastro',
      icon: 'screwdriver',
      filho: true,
      can: 'list',
      on: 'cadastro',
    },
    children: [
      {
        name: 'atualizaCadastro',
        path: '/beneficiarios/atualizacao-cadastral',
        components: { default: ATUALIZATION },
        meta: {
          requiresAuth: true,
          breadcrum: 'Atualização Cadastral',
          icon: 'user-edit',
          can: 'list',
          on: 'atualizacaocadastralbeneficiario',
          neto: true,
        },
      },
      {
        name: 'consultaBeneficiario',
        path: '/beneficiarios/consulta',
        components: { default: CONSULT },
        meta: {
          requiresAuth: true,
          breadcrum: 'Beneficiário',
          icon: 'male',
          can: 'list',
          on: 'consultabeneficiario',
          neto: true,
        },
      },
      {
        name: 'beneficiarioLogado',
        path: '/beneficiarios',
        components: { default: LISTBENEFICIARIO },
        meta: {
          requiresAuth: true,
          breadcrum: 'Beneficiário',
          icon: 'male',
          can: 'list',
          on: 'beneficiariologado',
          neto: true,
        },
      },
      {
        name: 'prestadorLogado',
        path: '/prestadores',
        components: { default: LISTPRESTADOR },
        meta: {
          requiresAuth: true,
          breadcrum: 'Prestador',
          icon: 'hospital',
          can: 'list',
          on: 'prestadorlogado',
          neto: true,
        },
      },
      ...Object.values(moduleRoutes).flatMap((module) => module.default),
    ],
  },
];

export default routes;
